export function formatDateGroup(dateInput) {
  if (!dateInput) return "Unknown";

  try {
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return "Unknown";

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const compareDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

    // Today
    if (compareDate.getTime() === today.getTime()) {
      return "Today";
    }

    // Yesterday
    if (compareDate.getTime() === yesterday.getTime()) {
      return "Yesterday";
    }

    // Last Week (within 7 days, but not today or yesterday)
    const lastWeek = new Date(today);
    lastWeek.setDate(today.getDate() - 7);
    if (compareDate > lastWeek && compareDate < yesterday) {
      return "Last week";
    }

    // This Month (current month, but not within the last week)
    const thisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    if (compareDate >= thisMonth && compareDate <= lastWeek) {
      return "This month";
    }

    // Last Month
    const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
    if (compareDate >= lastMonth && compareDate <= lastMonthEnd) {
      return "Last month";
    }

    // This Year (current year, but not this month or last month)
    const thisYear = new Date(today.getFullYear(), 0, 1);
    if (compareDate >= thisYear && compareDate < lastMonth) {
      return "This year";
    }

    // Older dates - show month and year
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
    });
  } catch (error) {
    return "Unknown";
  }
}

/**
 * Groups an array of items by their date field
 */
export function groupByDate(items, dateField = "lastModified") {
  if (!items || items.length === 0) return {};

  const groups = {};
  items.forEach((item) => {
    const dateKey = formatDateGroup(item[dateField]);
    if (!groups[dateKey]) groups[dateKey] = [];
    groups[dateKey].push(item);
  });

  for (const key in groups) {
    groups[key].sort((currentItem, nextItem) => new Date(nextItem[dateField]) - new Date(currentItem[dateField]));
  }

  const orderedGroups = {};
  const orderPriority = [
    "Today",
    "Yesterday",
    "Last week",
    "This month",
    "Last month",
    "This year",
  ];

  orderPriority.forEach((key) => {
    if (groups[key] && groups[key].length > 0) {
      orderedGroups[key] = groups[key];
    }
  });

  // Helper function to parse month-year format dates
  const parseMonthYear = (dateStr) => {
    try {
      const [month, year] = dateStr.split(' ');
      // Create a date object for the first day of the month
      return new Date(`${month} 1, ${year}`);
    } catch (error) {
      console.warn(`Error parsing date: ${dateStr}`, error);
      return new Date(0); // Return epoch date as fallback
    }
  };

  // Sort and add the remaining date groups (older dates in "Month Year" format)
  Object.keys(groups)
    .filter((key) => !orderPriority.includes(key))
    .sort((firstDateGroup, secondDateGroup) => {
      const firstDate = parseMonthYear(firstDateGroup);
      const secondDate = parseMonthYear(secondDateGroup);
      return secondDate - firstDate; // Descending order (newer dates first)
    })
    .forEach((key) => {
      orderedGroups[key] = groups[key];
    });

  return orderedGroups;
}
